import React from 'react'

function Enrolled() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
      <g id="Group_2535" data-name="Group 2535" transform="translate(-318.9 -639.9)">
        <circle id="Ellipse_135" data-name="Ellipse 135" cx="7" cy="7" r="7" transform="translate(321.9 642.9)" fill="#018e37" />
        <g id="Ellipse_250" data-name="Ellipse 250" transform="translate(318.9 639.9)" fill="none" stroke="#018e37" stroke-width="0.75">
          <circle cx="10" cy="10" r="10" stroke="none" />
          <circle cx="10" cy="10" r="9.625" fill="none" />
        </g>
      </g>
    </svg>
  )
}

export default Enrolled